
// change selected value
document.addEventListener('DOMContentLoaded', (event) => {
  $( '.variant-picker__option [type="radio"]' ).on( "click", function() {
    let selectedValue = $(this).val();
    $(this).parents('.variant-picker__option').find('variant-option-value').html(selectedValue);
  });

  document.querySelectorAll('x-listbox input[type="hidden"]').forEach((inputValue) => {
    inputValue.addEventListener('change', (e) => {
      const value = e.target.value;
      // Use jQuery to find the closest parent with class 'variant-picker__option'
      const $parent = $(e.target).closest('.variant-picker__option');
  
      // Update the variant-option-value element inside the parent
      $parent.find('variant-option-value').text(value);
    });
  });

  
  let allProducts = document.querySelectorAll('[bundle-products]');
  let variant_array = [];//Get selected variants To calculate Price
  
  // Disable Sold out Variant
  const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination, pro_element) => {
    const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
    optionValue?.toggleAttribute("hidden", !hasAtLeastOneCombination);
    if (pro_element.hasAttribute("hide-sold-out-variants")) {
      optionValue?.toggleAttribute("hidden", !available);
    } else {
      optionValue?.classList.toggle("is-disabled", !available);
    }
  }; 
  
  // Find Sold out Variant  
  const soldoutChecker = (optionSelectors, product, select_variant, pro_element) => {
    if (optionSelectors && optionSelectors[0] && select_variant != '') {
      product["options"][0]["values"].forEach((value, valueIndex) => {
        const hasAtLeastOneCombination = product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = product["variants"].some((variant) => variant["option1"] === value && variant["available"]);
        applyClassToSelector(optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination, pro_element);
        if (optionSelectors[1]) {
          product["options"][1]["values"].forEach((value2, valueIndex2) => {
            const hasAtLeastOneCombination2 = product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === select_variant[0]["option1"] && variant), hasAvailableVariant2 = product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === select_variant[0]["option1"] && variant["available"]);
            applyClassToSelector(optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2, pro_element);
            if (optionSelectors[2]) {
              product["options"][2]["values"].forEach((value3, valueIndex3) => {
                const hasAtLeastOneCombination3 = product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === select_variant[0]["option1"] && variant["option2"] === select_variant[0]["option2"] && variant), hasAvailableVariant3 = product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === select_variant[0]["option1"] && variant["option2"] === select_variant[0]["option2"] && variant["available"]);
                applyClassToSelector(optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3, pro_element);
              });
            }
          });
        }
      });
    }
  }
  //Price Format
  const priceUpdate = (variant_arrays) => {
    let totalSalePrice = 0;
    let totalMrpPrice = 0;
    variant_arrays.forEach((variant) => {
      if (!variant || !variant.price) return;
  
      totalSalePrice += parseInt(variant.price);
      // Use compare_at_price if available, else fallback to price
      if (variant.compare_at_price && variant.compare_at_price !== null) {
        totalMrpPrice += parseInt(variant.compare_at_price);
      } else {
        totalMrpPrice += parseInt(variant.price);
      }
    });
  
    const finalSalePrice = paisaToInr(totalSalePrice);
    const finalMrpPrice = paisaToInr(totalMrpPrice);
  
    const salePriceElement = document.querySelector('.product-info__price sale-price');
    const mrpPriceElement = document.querySelector('.product-info__price compare-at-price');
    
    if (salePriceElement && mrpPriceElement) {
      const sale = parseFloat(totalSalePrice);
      const mrp = parseFloat(totalMrpPrice);
      salePriceElement.textContent = `${finalSalePrice}`;
    
      if (mrp > sale) {
        mrpPriceElement.textContent = `${finalMrpPrice}`;
        mrpPriceElement.style.display = 'inline';
      } else {
        mrpPriceElement.style.display = 'none';
      }
    }
    calculateOfferPrice(parseFloat(totalSalePrice));
    calculateSavePrice(parseFloat(totalSalePrice));
  };
 
  function calculateOfferPrice(originalPrice) {
        //Best Price Offer Start
     let dedicatedProductOffer = document.querySelector('.offer__box_bar_container');
     let discountPercentage = dedicatedProductOffer?.getAttribute('data-discount');
     let priceWrapper = dedicatedProductOffer?.querySelector('.offer__first_text span');
    
      const proPrice = originalPrice / 100;
      const discountAmount = (proPrice * discountPercentage) / 100;
      const offerPrice = proPrice - discountAmount;
      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      let formattedString = currencyFormat.replace(/\{\{\s*amount\s*\}\}/, Math.round(offerPrice));
    
      // Remove all HTML tags from the formatted string (i.e., <span> tags)
      formattedString = formattedString.replace(/<\/?[^>]+(>|$)/g, "");
      priceWrapper.textContent = formattedString;

  }

  function calculateSavePrice(originalPrice) {
      const proPrice = originalPrice;
     let offerBoxes = document.querySelectorAll('.offer__slidezs_container .offer');
     offerBoxes.forEach((offerBox) => {
        let discountPercentage = offerBox.querySelector('.offers-section')?.getAttribute('data-discount');
        if(discountPercentage){
          let offerPriceWrapper = offerBox.querySelector('.offer-description span');
          const discountAmount = (proPrice * discountPercentage) / 100;
            offerPriceWrapper.textContent = paisaToInr(discountAmount);
        }
     })



    
  } 
  
  const paisaToInr = (paisa = 0) => {
    const inr = Math.round(paisa / 100);
  
    // Format with Indian comma style (e.g., 1,00,000)
    const formattedINR = inr.toLocaleString(`${Shopify.locale}-${Shopify.country}`);
  
    // Use Shopify currency format if available
    const currencyFormat = window?.themeVariables?.settings?.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window?.themeVariables?.settings?.moneyFormat;
  
    let formattedString = currencyFormat.replace(/\{\{\s*amount\s*\}\}/, formattedINR);
  
    // Remove any unexpected HTML tags (if needed)
    formattedString = formattedString.replace(/<\/?[^>]+(>|$)/g, '');
  
    return formattedString;
  };


  allProducts.forEach((pro_element, parentIndex) => {
    const productJsonElement = pro_element.querySelector('.product-json');
    if (!productJsonElement) return;
  
    const product_with_options = JSON.parse(productJsonElement.innerHTML);
    const product_variants = product_with_options['product'].variants;
    product_with_options['product']['options'] = product_with_options.options_with_values;
    let option_array = [];
    const fieldsets = pro_element.querySelectorAll('fieldset');
    let select_variant = '';
    if (fieldsets.length !== 0) {
      fieldsets.forEach((option, index) => {
        const current_index = index - 1;
        const allRadioOptions = option.querySelectorAll('input[type="radio"]');
        const selectInput = document.querySelectorAll(`x-listbox#product_id_${product_with_options['product'].id} input[type="hidden"]`);
        const updateOptionArray = () => {
          let selectedValue = '';
  
          const checkedRadio = option.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            selectedValue = checkedRadio.value;
          } else if (selectInput.length > 0) {
            selectedValue = selectInput[current_index]?.value || null ;
          }
  
          option_array[index] = selectedValue || null;
          const filledOptions = option_array.filter(value => value !== undefined && value !== null && value !== '');
          
          if (filledOptions.length === fieldsets.length){
            let variant_title = option_array.join(' / ');
            select_variant = product_variants.filter(x => variant_title === x.title);
            if (select_variant.length > 0) {
              const variantInput = pro_element.querySelector('.selectedVariantId');
              variant_array[parentIndex] = select_variant[0];//Assign  selected variant based on Parent index
              if (select_variant[0] && select_variant[0].available) {
                variantInput.value = select_variant[0].id;
              } else {
                variantInput.value = '';
              }               

              const optionSelectors = Array.from(pro_element.querySelectorAll("[data-option-selector]"));
              const list_popup = document.querySelector('x-popover[open] x-listbox');
              const option_position = document.querySelector('x-popover[open]')?.getAttribute('data-option-position');
              
              if (window.matchMedia("(max-width: 999px)").matches) {
                if (list_popup && option_position != null && !isNaN(option_position)) {
                  const index = parseInt(option_position, 10);
              
                  // Insert list_popup at the given index, shifting others to the right
                  optionSelectors.splice(index, 0, list_popup);
                }
              }
              soldoutChecker(optionSelectors, product_with_options['product'], select_variant, pro_element);
            }
            //ATC BTN State Toggle
            buttonEnable();
          }
           priceUpdate(variant_array);
        };
  
        // Run once initially
        updateOptionArray();
        
        document.addEventListener('listbox:appended', updateOptionArray);
        // Attach listeners
        if (allRadioOptions.length > 0) {
          allRadioOptions.forEach((radio) => {
            radio.addEventListener('change', updateOptionArray);
          });
        }
        if (selectInput.length > 0) {
          // selectInput.addEventListener('change', updateOptionArray);
          selectInput.forEach((select_input) => {
             select_input.addEventListener('change', updateOptionArray);
          }) 
        }
      });
    }
  });
});

const buttonEnable = () => {
  let allProducts = document.querySelectorAll('[name="variant id"]');
  let variant_array = [];
  for (var i = 0; i < allProducts.length; i++) {
    if($(allProducts[i]).val() != ''){       
      variant_array.push(Number($(allProducts[i]).val()));
    }
  }

  if(allProducts.length == variant_array.length){
    $("#bundleaddtocart span.btn_status").html(`Add to cart`);
    $("#bundleaddtocart").prop('disabled', false);
  } else if(allProducts.length != variant_array.length) {
    $("#bundleaddtocart span.btn_status").html(`Sold out`);
    $("#bundleaddtocart").prop('disabled', true);
  } else {
    $("#bundleaddtocart span.btn_status").html(`Add to cart`);
    $("#bundleaddtocart").prop('disabled', true);
  }
}

// function selectSize(){
//   let allProducts = document.querySelectorAll('.SizeSwatchList');
//   let active_size_check = 0;
//   for (var i = 0; i < allProducts.length; i++) {
//     let checkSizeSelect = false;
//     $(allProducts[i]).find('[type="radio"]').each(function () {
//       if($(this).is(":checked")){
//         checkSizeSelect = true;
//       }
//     });
//     let key = $(allProducts[i]).attr('key');
//     $('#select-size-message-bundle-'+key).show();
//     if(checkSizeSelect){
//       active_size_check = active_size_check + 1;
//       $('#select-size-message-bundle-'+key).hide();
//     }
//   }
//   if(active_size_check == allProducts.length){
//     allvariantSelect = true;
//   }
//   // console.log(allvariantSelect);
// }

async function customAddtocartCart(atcBtn = null){

  let allProducts = document.querySelectorAll('.product-info__variant-picker .variant-picker');
  let items = [];
  let bundle_variant_count = allProducts.length;
  for (var i = 0; i < allProducts.length; i++) {
    let variant = parseInt($(allProducts[i]).find('[name="variant id"]').val());
    let qty = 1;
    if(variant != null && variant != undefined){
      items.push({
        "id": variant,
        "quantity": qty
      });
    }
  }
  if(items.length > 0){

    if(atcBtn){
      // atcBtn.disabled = true;
      atcBtn.classList.add('tmp_disable')
      atcBtn.querySelector('div .btn_status').style.opacity = "0";
      atcBtn.querySelector('.button__loader').style.opacity = "1";
    }
    
    let formData = {
     "items": items
    };
    
    // let sectionsToBundle = ["variant-added"];
    // document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    // formData.sections = sectionsToBundle.join(",");
    
       try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formData)
          });
        
          const responseJson = await response.json(); 
        
          if (response.status === 200) {
            if (
              window.themeVariables.settings.cartType === "page" ||
              window.themeVariables.settings.pageType === "cart"
            ) {
              window.location.href = `${Shopify.routes.root}cart`;
              return;
            }
        
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];
        
            document.dispatchEvent(new CustomEvent("variant:add", {
              bubbles: true,
              detail: {
                items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
              }
            }));

            // document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            //   bubbles: true,
            //   detail: {
            //     baseEvent: "variant:add",
            //     cart: cartContent
            //   }
            // }));
            // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            //   bubbles: true
            // }));
            
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true
            }));
            document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
              bubbles: true,
              detail: null
            }));
            
            let cartDrawer = document.getElementById('cart-drawer');
            cartDrawer?.openFrom;
              if(atcBtn){
                  // atcBtn.disabled = false;
                  atcBtn.querySelector('div .btn_status').style.opacity = "1";
                  atcBtn.querySelector('.button__loader').style.opacity = "0";
                  atcBtn.classList.remove('tmp_disable')
              }
          } else {
            document.dispatchEvent(new CustomEvent("cart:error", {
              bubbles: true,
              detail: {
                error: responseJson["description"]
              }
            }));
          }
        
        } catch (error) {
          console.error('Request failed', error);
        }

    }
}